<template>
  <div>
    <!-- 按钮部分 -->
    <!-- <el-button type="text" @click="open()"></el-button> -->

    <!-- dialog弹框部分 -->
    <el-dialog
      :title="deleteBaocuo"
      :visible.sync="dialogFormVisible"
      :modal-append-to-body="false"
    >
      <!-- 弹框的内容部分 -->
      <div class="body" v-if="myitem != null">
        <!-- 弹框内容上半部分（分数结算页面） -->
        <div class="body_top">
          <!-- 悬浮框分数展示仪表盘部分 -->
          <div class="circle">
            <div class="progress" ref="init">
              <!-- <div ref="init"> -->
              <circleProgress
                :id="1"
                :width="yuanHeight"
                :radius="yuanHeight / 10"
                :progress="fenshu"
                :delay="200"
                :duration="1000"
                :barColor="'#FFCA33'"
                :backgroundColor="'#F4F4F6'"
                :isRound="true"
                :isAnimation="true"
              >
                <!-- </div> -->
                <template slot="top">
                  <div class="top_text">
                    <span class="size51">{{ myitem.score }}</span>
                    <span class="size17">分</span>
                  </div>
                </template>
                <template slot="bottom">
                  <div class="bottom_text">总分：{{ myitem.total_score }}</div>
                </template>
              </circleProgress>
            </div>
            <div class="circle_img">
              <div class="imgText">
                {{myitem.sign_status == 1?"恭喜您打卡成功":"写日记即可完成打卡"}}
              </div>
              <img
                src="https://fview.5kjs.com/activity/21sign/image/pc/textImage/jiayou.png"
                alt=""
                class="jiayou"
              />
            </div>
          </div>
          <!-- 右侧结算页面的正确率部分 -->
          <div class="circle_right">
            <div class="circle_right_item">
              <div class="number">{{ myitem.rate }}%</div>
              <div class="text_content">已击败网友</div>
            </div>
            <div class="circle_right_item">
              <div class="number">{{ myitem.use_time }}min</div>
              <div class="text_content">答题时长</div>
            </div>
            <div class="circle_right_item">
              <div class="number">{{ myitem.right_rate }}%</div>
              <div class="text_content">正确率</div>
            </div>
          </div>
        </div>
        <!-- 弹框内容下班部分（错题数据部分） -->
        <div class="body_bottom">
          <div class="mistakes">
            <div>本次答题 {{ myitem.done_num }}/{{ myitem.total_num }}</div>
            <!-- 判断打卡状态status=1为已打卡  否则显示后端返回值 -->
            <div v-if="myitem.sign_status == 1">
              打卡状态:
              <span style="color: #ff8232">{{ myitem.signContent }}</span>
            </div>
            <div v-else>
              <span style="color: #ff8232">{{ myitem.signContent }}</span>
            </div>
          </div>
          <div class="mistakes_from">
            <div class="mistakes_from_title">
              <div style="padding: 0 0.9375rem"></div>
              <div>做对试题</div>
              <div>做错试题</div>
              <div>已做/总题量</div>
              <div>正确率</div>
            </div>
            <div
              class="mistakes_from_content"
              v-for="(item, index) in myitem.item"
              :key="index"
            >
              <div class="leixing">{{ item.title }}</div>
              <div class="dui">{{ item.right_num }}</div>
              <div class="cuo">{{ item.error_num }}</div>
              <div class="zong">{{ item.make_num }}/{{ item.total_num }}</div>
              <div class="lv">{{ item.right_rate }}%</div>
            </div>
          </div>
          <!-- 章节部分 -->
          <!-- <div class="section_box">
            <div class="section_box_padding">
               章节标题
              <div class="section_title_box">
                 章节标题部分 
                <div class="section_title">标题标题</div>
                <div class="section_bar">
                  进度条部分 
                  <span>进度：</span>
                  <div class="section_bar_wai">
                    <div class="section_bar_nei"></div>
                  </div>
                  <span>99/99</span>
                </div>
              </div>
              章节循环元素部分 
              <div class="section_item">
              左侧章节标题部分 
                <div class="section_class_title_box">
                  <span class="section_class_title">教育观</span>
                  <span class="section_class_bar">99/99</span>
                </div>
                <div class="section_class_btn">
                  <span>立即刷题</span>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <div slot="footer" class="dialog-footer" v-if="myitem != null">
        <!-- <div class="footer_box">
          <el-button type="primary" @click="dialogFormVisible = false"
            >返回列表</el-button
          >
        </div> -->
        <div class="btn_item back_btn" @click="dialogFormVisible = false">
          返回列表
        </div>
        <router-link
          :to="{
            path: shareBtnRouter,
            query: { type: 'back', camp: this.$route.query.camp },
          }"
        >
          <div class="btn_item share_box">
            写日记 <i class="iconfont icon-bi"></i>
          </div>
        </router-link>
        <a :href="myitem.paper_error"
          ><div class="btn_item">查看本次错题</div></a
        >
        <a :href="myitem.paper_analysis"
          ><div class="btn_item">查看解析</div></a
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import circleProgress from "@/components/detail_child/circle-progress.vue";
import { mapState, mapMutations } from "vuex";
export default {
  name: "testDiaLog",
  components: { circleProgress },
  data() {
    return {
      dialogFormVisible: false,
      // 做题分数百分比
      myitem: null,
      //是否做完题返回
      status: 0,
      // 课程ID
      lesson_id: null,
      token: localStorage.getItem("token"),
      agency_id: localStorage.getItem("agency_id"),
      // 动态设置圆的大小
      yuanHeight: 200,
      // 去分享按钮的路由路径
      shareBtnRouter: "",
      // 章节打卡识别ID
      knowledge_id: null,
    };
  },
  computed: {
    ...mapState(["oneOpen"]),
    // 计算分数百分比
    fenshu() {
      var myfenshu = 0;
      if (this.myitem != null) {
        myfenshu = (this.myitem.score / this.myitem.total_score) * 100;
      }
      return myfenshu;
    },
    // 动态返回异步值去除报错
    deleteBaocuo() {
      var title = null;
      if (this.myitem != null) {
        title = this.myitem.title;
      }
      return title;
    },
  },
  methods: {
    ...mapMutations(["myOneOpen"]),
    // 模态框的触发事件
    open() {
      this.dialogFormVisible = true;
    },
    // 请求做题之后的成绩结算页面
    getItemResult() {
      this.$axios
        .get("/getItemResult", {
          params: {
            token: this.token,
            agency_id: this.agency_id,
            lesson_id: this.lesson_id,
          },
        })
        .then((doc) => {
          console.log(doc);
          this.myitem = doc;
          if (doc.code == 200) {
            if (this.status == 1) {
              this.open();
            }

            this.myOneOpen(false);
          } else if (doc.data.code == 201) {
            this.myOneOpen(true);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 章节成绩结算页
    getKnowledgeResult() {
      this.$axios
        .get("/getKnowledgeResult", {
          params: {
            token: this.token,
            agency_id: this.agency_id,
            lesson_id: this.lesson_id,
            knowledge_id: this.knowledge_id,
          },
        })
        .then((doc) => {
          console.log(doc);
          this.myitem = doc;
          if (doc.code == 200) {
            if (this.status == 1) {
              this.open();
            }

            this.myOneOpen(false);
          } else if (doc.data.code == 201) {
            this.myOneOpen(true);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.status = this.$route.query.status;
    this.lesson_id = this.$route.params.id;
    this.knowledge_id = this.$route.query.knowledge_id;
    // 如果不是章节打卡页面则请求原来的结算接口
    if (this.$route.query.knowledge_id == null) {
      this.getItemResult();
      console.log("打卡结算");
    } else {
      this.getKnowledgeResult();
    }

    // 动态获取去分析按钮的路由
    this.shareBtnRouter = "/Detail/study/" + this.$route.query.camp;

    // 动态设置圆形进度条大小

    //  实时监控浏览器窗口变化并动态设置大小
    window.onresize = () => {
      if (this.myitem != null) {
        if (this.$refs) {
          this.yuanHeight = this.$refs.init.offsetHeight;
        }
      }
    };
    // 这里用来在页面加载的时候就让圆形进度条匹配当前屏幕大小
    var that = this;
    var autoInfo = setInterval(function () {
      if (that.myitem != null) {
        if (that.$refs) {
          that.yuanHeight = that.$refs.init.offsetHeight;
          clearInterval(autoInfo);
        }
      }
    }, 300);
  },
  filters: {},
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog {
  margin-top: 6vh !important;
  width: 49.75rem;
  max-height: 60.125rem;
  background: #ffffff;
  border-radius: 0.3125rem;
  overflow-y: auto;
  // 头部
  .el-dialog__header {
    padding: 0 1.5625rem 0 3.75rem;
    height: 4rem;
    // border-bottom: 1px solid #eee;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .el-dialog__title {
      font-size: 1rem;
      font-family: " Microsoft YaHei";
      font-weight: 400;
      color: #4f4f4f;
    }
    .el-icon-close:before {
      font-size: 1.25rem;
    }
  }
  // 内容部分
  .el-dialog__body {
    padding: 0;
    // 弹框内容部分
    .body {
      display: flex;
      flex-direction: column;
      // height: 37.1875rem;
      width: 100%;
      border-top: 0.0625rem solid #eee;
      // 弹框内容展示上半部分 （分数展示部分）
      .body_top {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 22.625rem;
        width: 100%;
        border-bottom: 0.0625rem solid #eee;
        // 分数展示仪表盘部分
        .circle {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 27.875rem;
          height: 100%;
          border-right: 0.0625rem solid #eee;
          .progress {
            // height: 22.625rem;
            .top_text {
              width: 8.625rem;
              font-family: "Source Han Sans CN";
              font-weight: bold;
              color: #3b464d;
              font-weight: Bold;
              .size51 {
                flex: 1;
                font-size: 3.1875rem;
              }
              .size17 {
                font-size: 1.0625rem;
              }
            }
            .bottom_text {
              font-size: 0.9375rem;
              font-family: " Microsoft YaHei";
              font-weight: 400;
              color: #aaadb2;
            }
          }
          .circle_img {
            width: 18.5rem;
            height: 5.375rem;
            position: relative;
            img {
              width: 100%;
              height: 100%;
            }
            .imgText{
              position:absolute;
              width: 100%;
              top: 1.2rem;
              text-align: center;
              font-size: 1.2rem;
              line-height: 2rem;
              color: #eee;
            }
          }
        }
        // 右侧结算页面的正确率部分
        .circle_right {
          height: 100%;
          flex: 1;
          .circle_right_item {
            margin-top: 3rem;
            width: 100%;
            text-align: center;
            .number {
              font-size: 1.625rem;
              font-family: "Microsoft YaHei";
              font-weight: 400;
              color: #3b464d;
            }
            .text_content {
              font-size: 1rem;
              font-family: "Microsoft YaHei";
              font-weight: 400;
              color: #afb1b5;
            }
          }
        }
      }
      // 弹框内容展示下半部分（错题数据部分）
      .body_bottom {
        flex: 1;
        width: 100%;
        height: 100%;
        // border: 1px solid red;
        .mistakes {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          padding: 0 3.6875rem;
          height: 3.125rem;
          font-size: 0.875rem;
          font-family: " PingFang SC";
          font-weight: 500;
          color: #636363;
          line-height: 3.125rem;
        }
        .mistakes_from {
          width: 100%;
          .mistakes_from_title {
            // padding: 0 3.6875rem;
            display: flex;
            flex-direction: row;
            // width: 48.0625rem;
            height: 3.125rem;
            background: #f4f4f4;
            div {
              flex: 1;
              text-align: center;
              line-height: 3.125rem;
              font-size: 0.75rem;
              font-family: "PingFang SC";
              font-weight: 500;
              color: #90909e;
            }
          }
          .mistakes_from_content {
            display: flex;
            flex-direction: row;
            // height: 3.125rem;
            border-bottom: 0.0625rem solid #eeeeee;
            div {
              padding: 0.9375rem 0;
              flex: 1;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              text-align: center;
              // line-height: 3.125rem;
              font-family: "PingFang SC";
              font-weight: 500;
              font-size: 0.875rem;
            }
            .leixing {
              color: #2a2a44;
              padding: 0 0.9375rem;
            }
            .dui {
              color: #1bd677;
            }
            .cuo {
              color: #ff8232;
            }
            .zong {
              color: #2a2a44;
            }
            .lv {
              color: #ff8135;
            }
          }
        }
        // 章节部分
        .section_box {
          border-top: 0.625rem solid #f4f4f4;
          .section_box_padding {
            // 章节标题栏部分
            .section_title_box {
              padding: 0 3.6rem;
              height: 3.4375rem;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              border-bottom: 1px solid #eeeeee;
              .section_title {
                font-size: 0.875rem;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #3e3939;
              }
              .section_bar {
                display: flex;
                flex-direction: row;
                align-items: center;
                .section_bar_wai {
                  margin-right: 0.3125rem;
                  width: 7.25rem;
                  height: 0.375rem;
                  background: #e7ebee;
                  .section_bar_nei {
                    width: 50%;
                    height: 0.375rem;
                    background: #ff8673;
                    border-radius: 0px 0.1875rem 0.1875rem 0px;
                  }
                }
              }
            }
            // 标题课程循环元素部分
            .section_item {
              padding: 0 3.6rem;
              height: 3.4375rem;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              border-bottom: 1px dashed #eeeeee;
              .section_class_title_box {
                .section_class_title {
                  margin-right: 0.5rem;
                  font-size: 0.875rem;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #2a2a44;
                }
                .section_class_bar {
                  font-size: 0.875rem;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #9fa5ad;
                }
              }
              .section_class_btn {
                cursor: pointer;
                width: 4.875rem;
                height: 1.625rem;
                background: #ffba61;
                border-radius: 0.8125rem;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                span {
                  font-size: 0.75rem;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #ffffff;
                }
              }
            }
          }
        }
      }
    }
  }
  // 模态框侧按钮部分
  .el-dialog__footer {
    height: 6.25rem;
    width: 100%;
    .dialog-footer {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      height: 100%;
      .btn_item {
        margin: 0 0.625rem;
        padding: 0 2.3125rem;
        height: 2.1875rem;
        border-radius: 1.125rem;
        background: linear-gradient(90deg, #ff9c5c, #ff5d02);
        line-height: 2.1875rem;
        font-size: 0.875rem;
        font-family: "Microsoft YaHei";
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;
      }
      .share_box {
        background: #ffffff;
        color: #ff722c;
        border: 1px solid #ff722c;
        .icon-bi::before {
          color: #ff4200;
        }
      }
      .back_btn {
        background: #9fa5ad;
      }
    }
  }
}
</style>